(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/store/order-home-context.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/store/order-home-context.js');
"use strict";

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  createContext,
  useCallback,
  useContext,
  useReducer,
  useEffect
} = React;
const OrderHomeContext = createContext();
const {
  useLocalStorage
} = svs.ticketsOrderHome.hooks;
const ORDER_HOME_STATE_KEY = 'orderTickets';
const ORDER_HOME_STATE_DOMAIN = 'tickets-order-home';
const ORDER_HOME_STATE_EXPIRATION = svs.components.Storage.constants.EXPIRES_15M;
const {
  SHIPPING_COST,
  MINIMUM_TOTAL_ORDER_PRICE
} = svs.ticketsOrderHome.utils.constants;
const {
  isMaximumQuantityWeightReachedForTicket
} = svs.ticketsOrderHome.utils;
const buildCart = tickets => {
  const totalOrderCount = tickets.reduce((acc, ticket) => acc + ticket.count, 0);
  const totalOrderPrice = tickets.reduce((acc, ticket) => acc + ticket.count * ticket.price, totalOrderCount > 0 ? SHIPPING_COST : 0);
  const minimumTotalOrderPriceNotReached = totalOrderPrice < MINIMUM_TOTAL_ORDER_PRICE;
  const cartTickets = tickets.map(ticket => _objectSpread(_objectSpread({}, ticket), {}, {
    totalPrice: ticket.count * ticket.price,
    incrementDisabled: isMaximumQuantityWeightReachedForTicket(ticket, tickets),
    decrementDisabled: ticket.count <= 0
  })).filter(ticket => ticket.count > 0);
  return {
    tickets: cartTickets,
    totalOrderCount,
    totalOrderPrice,
    minimumTotalOrderPriceNotReached,
    shippingCost: SHIPPING_COST
  };
};
const createInitialState = function () {
  var _greetings$;
  let {
    tickets: savedOrderTickets = [],
    receiver = {
      other: false,
      search: {},
      details: {}
    },
    personalGreeting = '',
    greetingMessage = ''
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const availableTickets = svs.ticketsOrderHome.data.config.orderHome.tickets.filter(ticket => ticket.available).map(ticket => _objectSpread({}, ticket));
  const {
    greetings
  } = svs.ticketsOrderHome.data.config.orderHome.orderHomeMessage;
  const tickets = availableTickets.map(ticket => {
    var _savedOrderTickets$fi;
    return {
      id: ticket.id,
      count: ((_savedOrderTickets$fi = savedOrderTickets.find(_ref => {
        let {
          id
        } = _ref;
        return id === ticket.id;
      })) === null || _savedOrderTickets$fi === void 0 ? void 0 : _savedOrderTickets$fi.count) || 0,
      price: ticket.price,
      name: ticket.name,
      image: _objectSpread({}, ticket.image)
    };
  });
  personalGreeting = personalGreeting || (greetings === null || greetings === void 0 || (_greetings$ = greetings[0]) === null || _greetings$ === void 0 ? void 0 : _greetings$.personalGreetingInput) || '';
  const cart = buildCart(tickets);
  return {
    availableTickets,
    tickets,
    cart,
    order: {},
    receiver,
    personalGreeting,
    greetingMessage
  };
};
const reducer = (state, action) => {
  let tickets;
  switch (action.type) {
    case 'INCREMENT_ORDER_COUNT':
      tickets = state.tickets.map(ticket => {
        if (ticket.id === action.payload.id) {
          return _objectSpread(_objectSpread({}, ticket), {}, {
            count: ticket.count + 1
          });
        }
        return ticket;
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        tickets,
        cart: buildCart(tickets)
      });
    case 'DECREMENT_ORDER_COUNT':
      tickets = state.tickets.map(ticket => {
        if (ticket.id === action.payload.id) {
          return _objectSpread(_objectSpread({}, ticket), {}, {
            count: ticket.count - 1
          });
        }
        return ticket;
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        tickets,
        cart: buildCart(tickets)
      });
    case 'SET_ORDER':
      return _objectSpread(_objectSpread({}, state), {}, {
        order: _objectSpread({}, action.payload)
      });
    case 'SET_RECEIVER':
      return _objectSpread(_objectSpread({}, state), {}, {
        receiver: action.payload
      });
    case 'SET_RECEIVER_SEARCH_RESULT':
      return _objectSpread(_objectSpread({}, state), {}, {
        receiver: _objectSpread(_objectSpread({}, state.receiver), {}, {
          results: _objectSpread(_objectSpread({}, state.receiver.results), {}, {
            [action.payload.searchCacheKey]: action.payload.searchResult
          }),
          result: action.payload.searchResult.result
        })
      });
    case 'SET_PERSONAL_GREETING_INPUT':
      return _objectSpread(_objectSpread({}, state), {}, {
        personalGreeting: action.payload
      });
    case 'SET_GREETING_INPUT':
      return _objectSpread(_objectSpread({}, state), {}, {
        greetingMessage: action.payload
      });
    case 'RESET_STATE':
      return createInitialState();
    default:
      return state;
  }
};
const OrderHomeProvider = _ref2 => {
  let {
    children
  } = _ref2;
  const [savedOrder, setSavedOrder] = useLocalStorage(ORDER_HOME_STATE_KEY, ORDER_HOME_STATE_DOMAIN, [], ORDER_HOME_STATE_EXPIRATION);
  const [state, dispatch] = useReducer(reducer, savedOrder, createInitialState);
  useEffect(() => {
    setSavedOrder({
      tickets: state.tickets.map(_ref3 => {
        let {
          id,
          count
        } = _ref3;
        return {
          id,
          count
        };
      }),
      receiver: state.receiver,
      personalGreeting: state.personalGreeting,
      greetingMessage: state.greetingMessage
    });
  }, [state, setSavedOrder]);
  const incrementOrderCount = useCallback(id => {
    svs.ticketgames.ticketUtility.utils.tracking.trackOrderHomeCartTicketCountChange(id, 1);
    dispatch({
      type: 'INCREMENT_ORDER_COUNT',
      payload: {
        id
      }
    });
  }, []);
  const decrementOrderCount = useCallback(id => {
    svs.ticketgames.ticketUtility.utils.tracking.trackOrderHomeCartTicketCountChange(id, -1);
    dispatch({
      type: 'DECREMENT_ORDER_COUNT',
      payload: {
        id
      }
    });
  }, []);
  const setOrder = useCallback(_ref4 => {
    let {
      orderItems,
      referenceId,
      giftAddress = null,
      isGift = false
    } = _ref4;
    dispatch({
      type: 'SET_ORDER',
      payload: {
        orderItems,
        referenceId,
        giftAddress,
        isGift
      }
    });
  }, []);
  const setReceiver = useCallback(receiver => {
    dispatch({
      type: 'SET_RECEIVER',
      payload: receiver
    });
  }, []);
  const setReceiverSearchResult = useCallback((searchCacheKey, searchResult) => {
    dispatch({
      type: 'SET_RECEIVER_SEARCH_RESULT',
      payload: {
        searchCacheKey,
        searchResult
      }
    });
  }, []);
  const setPersonalGreetingInput = greeting => {
    dispatch({
      type: 'SET_PERSONAL_GREETING_INPUT',
      payload: greeting
    });
  };
  const setGreetingInput = message => {
    dispatch({
      type: 'SET_GREETING_INPUT',
      payload: message
    });
  };
  const resetState = useCallback(() => {
    dispatch({
      type: 'RESET_STATE'
    });
  }, []);
  return React.createElement(OrderHomeContext.Provider, {
    value: {
      state,
      incrementOrderCount,
      decrementOrderCount,
      setOrder,
      setReceiver,
      setReceiverSearchResult,
      resetState,
      setPersonalGreetingInput,
      setGreetingInput
    }
  }, children);
};
const useOrderHomeContext = () => useContext(OrderHomeContext);
setGlobal('svs.ticketsOrderHome.context', {
  OrderHomeContext,
  OrderHomeProvider,
  useOrderHomeContext
});

 })(window);